// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"W7-z"};